import { API_CONSULT } from 'Constants/client-modules';

import * as ACTION_TYPES from './types';

export function allMediaRetrieve(params = {}) {
  return {
    types: [
      ACTION_TYPES.ALL_MEDIA_RETRIEVE_REQUESTED,
      ACTION_TYPES.ALL_MEDIA_RETRIEVE_SUCCEED,
      ACTION_TYPES.ALL_MEDIA_RETRIEVE_FAILED,
    ],
    promise: client => client.get('/messages/images', { params }),
    options: {
      clientName: API_CONSULT,
    },
  };
}

export function getGalleryViewBackward(params = {}) {
  return {
    types: [
      ACTION_TYPES.GALLERY_VIEW_BACKWARD_REQUESTED,
      ACTION_TYPES.GALLERY_VIEW_BACKWARD_SUCCEED,
      ACTION_TYPES.GALLERY_VIEW_BACKWARD_FAILED,
    ],
    promise: client => client.get('/messages/images', { params: { ...params, direction: 0 } }),
    options: {
      clientName: API_CONSULT,
    },
  };
}

export function getGalleryViewForward(params = {}) {
  return {
    types: [
      ACTION_TYPES.GALLERY_VIEW_FORWARD_REQUESTED,
      ACTION_TYPES.GALLERY_VIEW_FORWARD_SUCCEED,
      ACTION_TYPES.GALLERY_VIEW_FORWARD_FAILED,
    ],
    promise: client => client.get('/messages/images', { params: { ...params, direction: 1 } }),
    options: {
      clientName: API_CONSULT,
    },
  };
}

export function setPreviewImage(previewImage) {
  return {
    type: ACTION_TYPES.GALLERY_SET_PREVIEW_IMAGE,
    payload: {
      previewImage,
    },
  };
}

export function openGallery(conversationId, previewImage, images = []) {
  return {
    type: ACTION_TYPES.GALLERY_TRIGGER_OPEN,
    payload: {
      previewImage,
      conversationId,
      images,
    },
  };
}

export function closeGallery() {
  return {
    type: ACTION_TYPES.GALLERY_TRIGGER_CLOSE,
  };
}
